import { useTranslation } from "react-i18next"
import { Step } from "react-joyride"
import { ScrollRule } from "../UserManual"
import { CustomBodyText, CustomHeader } from "../manualComponets"

export const historicalDataScrollRules: {
	target: string
	opts: ScrollRule
}[] = [
	{
		target: "#header-user-manual",
		opts: {
			containerSelector: "#body-layout",
			x: {
				offset: -24,
				align: "end",
			},
			y: {
				offset: 10000,
				align: "end",
			},
		},
	},
	{
		target: "#plot-card",
		opts: {
			containerSelector: "#plot-list-container",
			x: {
				offset: 24,
				align: "start",
			},
			y: {
				offset: 0,
				align: "start",
			},
		},
	},
]

export const historicalDataSteps = (
	translationFunc?: ReturnType<typeof useTranslation>["t"]
): Step[] => {
	const t = translationFunc ?? ((text: string) => text)
	return [
		{
			target: "#header-user-manual",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.pageHeader.header")}</CustomHeader>
					<CustomBodyText>{t("historicalData.pageHeader.content")}</CustomBodyText>
				</div>
			),
			disableBeacon: true,
			placement: "left-start",
		},
		{
			target: "#add-plot-card",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.addPlotCard.header")}</CustomHeader>
					<CustomBodyText>{t("historicalData.addPlotCard.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom",
		},
		{
			target: "#plot-card",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.plotCard.header")}</CustomHeader>
					<CustomBodyText>{t("historicalData.plotCard.content")}</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#time-selection",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.timeSelection.header")}</CustomHeader>
					<CustomBodyText>{t("historicalData.timeSelection.content")}</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#time-series-range-shift",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.timeSeriesRangeShift.header")}</CustomHeader>
					<CustomBodyText>
						{t("historicalData.timeSeriesRangeShift.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top-end",
		},
		{
			target: "#time-series-visibility",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.timeSeriesVisibility.header")}</CustomHeader>
					<CustomBodyText>
						{t("historicalData.timeSeriesVisibility.content")}
					</CustomBodyText>
				</div>
			),
			placement: "top",
		},
		{
			target: "#plot-btn-mode-visibility-toggle",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("historicalData.plotBtnModeVisibilityToggle.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("historicalData.plotBtnModeVisibilityToggle.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#plot-btn-toggle-interpolated-raw",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>
						{t("historicalData.plotBtnToggleInterpolatedRaw.header")}
					</CustomHeader>
					<CustomBodyText>
						{t("historicalData.plotBtnToggleInterpolatedRaw.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#plot-btn-delete-plot",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.plotBtnDeletePlot.header")}</CustomHeader>
					<CustomBodyText>{t("historicalData.plotBtnDeletePlot.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#plot-btn-quick-add-sensor",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.plotBtnQuickAddSensor.header")}</CustomHeader>
					<CustomBodyText>
						{t("historicalData.plotBtnQuickAddSensor.content")}
					</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
		{
			target: "#plot-btn-settings",
			content: (
				<div className={`flex w-125 flex-col`}>
					<CustomHeader>{t("historicalData.plotBtnSettings.header")}</CustomHeader>
					<CustomBodyText>{t("historicalData.plotBtnSettings.content")}</CustomBodyText>
				</div>
			),
			placement: "bottom-end",
		},
	]
}
